export default {"src":"/_next/static/media/logo.9afc35a7.svg","height":258,"width":1200};